import { xenvActionFactory } from '../xenv';
import { passengerScanCode, alimpScanCode, wxmpScanCode, weixinScanCode } from '../platform/xenv';
const xenvScanCodeConfig = {
    'alimp': alimpScanCode,
    'passenger': passengerScanCode,
    'weixin': weixinScanCode,
    'wxmp': wxmpScanCode,
};
export const scanCode = () => {
    const fn = xenvActionFactory('scanCode', xenvScanCodeConfig);
    return fn();
};
